import React, { useContext, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import Icon from '@ellucian/ds-icons/lib/es6/Icon';
import {
    ActionMenu,
    ActionMenuItem,
    makeStyles,
    useMediaQuery
} from '@ellucian/react-design-system/core';
import { spacing30, spacing50 } from '@ellucian/react-design-system/core/styles/tokens';
import GlobalLocaleContext from '../GlobalLocale/GlobalLocaleContext';
import { useIntl } from 'react-intl';
import { useTheme } from '@mui/material';
import classnames from 'classnames';
import isInIframe from '../../utilities/isInIframe';
import { selectTenant } from '../../redux/admin/slices/adminBaseSlice';
import { useSelector } from 'react-redux';
import { getDisplayForLocale } from '../Helpers/messagesHelpers';
const useStyles = makeStyles(() => ({
    root: {
        margin: `${spacing30} ${spacing50} 0 ${spacing50}`,
        '&.mobile': {
            marginTop: '5rem',
        },
    },
}));
const LanguageDropdown = props => {
    const {
        classes: classesProp,
    } = props;
    const classes = useStyles();
    const [value, setValue] = useState('');
    const globalLanguageCtx = useContext(GlobalLocaleContext);
    const { globalLocale, updateGlobalLocale } = globalLanguageCtx;
    const { formatMessage } = useIntl();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isEmbedded = useMemo(() => isInIframe(), []);
    const tenant = window.PRELOADED_STATE?.globalSettings || useSelector(selectTenant);
    useEffect(() => {
        if (globalLocale) {
            setValue(globalLocale);
            return;
        }
        setValue('');
    }, [globalLocale]);
    const locales = useMemo(() => {
        if (tenant.settingMessages.languages) {
            let result = Object.keys(tenant.settingMessages.languages).map(l => ({
                ...tenant.settingMessages.languages[l],
                key: l,
            }));
            result.sort(function (a, b) {
                let x = a.displayName.toLowerCase();
                let y = b.displayName.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
            });
            return result;
        }
        return [];
    }, []);
    const languages = useMemo(() => {
        const actions = locales.map(it => {
            let label = getDisplayForLocale(it.key, formatMessage);
            if (it.key === value) {
                label = formatMessage({ id: 'currentlySelectedLanguage' }, { language: label });
            }
            return {
                ...it,
                callback: () => {
                    updateGlobalLocale(it.key);
                    setValue(it.key);
                },
                label
            };
        });
        return actions;
    }, [formatMessage, locales, value]);
    const rootClasses = useMemo(() => {
        return classnames(classes.root, {
            mobile: isMobile && !isEmbedded,
        },
        classesProp?.root);
    }, [classes, isMobile, classesProp]);
    if (languages.length <= 1) {
        return null;
    }
    return (
        <div className={rootClasses}>
            <ActionMenu
                id="language-dropdown"
                icon={<Icon large={true} name="globe" />}
            >
                {
                    languages.map((action, index) => (
                        <ActionMenuItem onClick={action.callback} key={index}>
                            {action.label}
                        </ActionMenuItem>
                    ))
                }
            </ActionMenu>
        </div>
    );
};
LanguageDropdown.propTypes = {
    classes: PropTypes.object,
};
export default LanguageDropdown;
